import Command from '@ckeditor/ckeditor5-core/src/command';

export default class ChevronNavCommand extends Command {
  execute( val ) {
    this.editor.fire( 'chevronnav', val );
  }
}
